import * as React from 'react';
import { styled } from '@glitz/react';
import { useDynamicData } from '@avensia/excite';
import { ContentList } from '@avensia/excite-contentful';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import { Block } from 'webapp/components/page-layout';
import { HydrationOptionsProvider } from '@avensia/excite/progressive-hydration';

type PropType = {
  pdpContentContext: NordicNest.Api.PdpContentContext;
};

export const ProductPageContent = (props: PropType) => {
  const [productPageContent] = useDynamicData<NordicNest.Api.PdpContentApiModel>({
    context: props.pdpContentContext,
  });
  return productPageContent && productPageContent.content.filter(c => c?.content).length > 0 ? (
    <Base>
      <HydrationOptionsProvider renderInsteadOfHydrate>
        {productPageContent.content.map(
          contentItem => contentItem?.content && <ContentList key={contentItem.id} items={contentItem.content.items} />,
        )}
      </HydrationOptionsProvider>
    </Base>
  ) : null;
};

const Base = styled(
  Block,
  createMinLargeViewportDecorator({
    margin: { y: t => t.spacing.l },
  }),
  {
    margin: { y: t => t.spacing.m },
    hyphens: 'auto',
  },
);
